module.exports = __webpack_public_path__ + "52abd4e5aafb80d42eb647e916d99547.MP3";